<template>
  <div>
    <!-- new code -->
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar class="toolbar">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Question</v-toolbar-title>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="show = false">Close</v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <!-- snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- overlay -->
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin -->

        <!-- QQ?? :{{ sel_crs.length }}
        <template v-if="sel_crs.length > 0">
          
        </template> -->
        <!-- {{ sel_crs }} -->

        <v-row justify="center" dense>
          <v-radio-group v-model="radios" mandatory row class="no-display">
            <v-radio label="From Question Bank" value="qb" color="#0f2027" @change="
      questionbank = true;
    show_row = false;
    "></v-radio>
            <v-radio v-if="show_on_the_fly" label="On The Fly" value="onf" color="#0f2027" @change="
      questionbank = false;
    show_row = true;
    "></v-radio>

          </v-radio-group>
        </v-row>

        <v-row justify="center" dense v-if="show_row">
          <v-col cols="12" sm="4" md="3" v-if="quiztype_list != ''">
            <p><v-icon color="error">*</v-icon><b>Quiz Type List</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="quiztype" :items="quiztype_list"
              item-text="display_name" item-value="name" label="Quiz Type" outlined persistent-hint
              hint="Please Select Quiz Type" />
          </v-col>
          <v-col cols="12" sm="4" md="3" v-if="chapters_list != ''">
            <p><v-icon color="error">*</v-icon><b>Chapter List</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="chapter" :items="chapters_list"
              item-text="name" item-value="id" label="Chapter" outlined persistent-hint hint="Please Select Chapter" />
          </v-col>
          <v-col cols="12" sm="4" md="3" v-if="Level_list != ''">
            <p><v-icon color="error">*</v-icon><b>Difficulty Level List</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="Level" item-value="Level_id"
              :items="Level_list" item-text="Level_name" label="Difficulty Level" outlined persistent-hint
              hint="Please Select Difficulty Level" />
          </v-col>
        </v-row>
        <!-- quiz type--{{ quiztype }} -->
        <!-- chapter-- {{ chapter }} -->

        <!-- <qb
      v-if="questionbank == true"
      :chapters_list="chapters_list"
      :sel_crs="sel_crs"
    ></qb> -->
        <qb v-if="questionbank == true" :sel_crs="sel_crs" :Level_listAll="Level_listAll"></qb>
        <mcq v-if="questionbank == false && quiztype === 'MCQ' && Level" :sel_crs="sel_crs" :chapter="chapter"
          :quiztype="quiztype" :Level="Level">
        </mcq>
        <subjective v-if="questionbank == false && quiztype === 'SUBJECTIVE' && Level" :sel_crs="sel_crs"
          :chapter="chapter" :quiztype="quiztype" :Level="Level"></subjective>
        <mwa v-if="questionbank == false && quiztype === 'MultiWordAnswer' && Level
      " :sel_crs="sel_crs" :chapter="chapter" :quiztype="quiztype" :Level="Level"></mwa>
        <mtp v-if="questionbank == false && quiztype === 'MTP' && Level" :sel_crs="sel_crs" :chapter="chapter"
          :quiztype="quiztype" :Level="Level"></mtp>
        <swa v-if="questionbank == false && quiztype === 'SWA' && Level" :sel_crs="sel_crs" :chapter="chapter"
          :quiztype="quiztype" :Level="Level"></swa>
        <truefalse v-if="questionbank == false && quiztype === 'TrueFalse' && Level" :sel_crs="sel_crs"
          :chapter="chapter" :quiztype="quiztype" :Level="Level"></truefalse>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import QuestionBank from "./QuestionBank";
// import LiveMCQ from "./LiveMCQ";
import LiveMCQ from "./LiveMCQNew";

import LiveSubjective from "./LiveSubjective";
import LiveMultiWordAnswer from "./LiveMultiWordAnswer";
import LiveMTP from "./LiveMTPNew";
import LiveSingleWordAnswer from "./LiveSingleWordAnswer";
import LiveTrueFalse from "./LiveTrueFalse";

export default {
  components: {
    qb: QuestionBank,
    mcq: LiveMCQ,
    subjective: LiveSubjective,
    mwa: LiveMultiWordAnswer,
    mtp: LiveMTP,
    swa: LiveSingleWordAnswer,
    truefalse: LiveTrueFalse,
  },
  props: ["sel_crs", "value"],
  data: () => ({
    show_row: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    chapters_list: [],
    Level: [],
    Level_list: [],
    Level_listAll: [],
    chapter: "",
    quiztype_list: [],
    quiztype: "",
    radios: null,
    Level: null,
    questionbank: true, show_on_the_fly: false,
    ///////////////////////////////////////////////
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////
    async call() {
      const formdata = {
        sel_crs: this.sel_crs,
      };
      this.overlay = true;
      try {
        const res = await axios.post("/liveClass/getQuestions", formdata);
        if (res.data.flag == "YES") {
          this.show_on_the_fly = res.data.show_on_the_fly;
          this.chapters_list = res.data.chapters;
          this.quiztype_list = res.data.quiztype;
          if (this.chapters_list == '' || this.chapters_list == null) {
            this.showSnackbar("red", "Chapters Not Added...Please Add Chapters...");
            return
          }
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        this.overlay = false;
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
        this.overlay = false;
      } finally {
        console.log("bye...");
        this.overlay = false;
      }
    },
    async getdifficultylevel() {
      const data = {

      };
      axios
        .post("/QuizQuestionBank/getdifficultylevel", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "Please add Difficulty Level First..!!!");
            return
          }
          else {
            this.Level_list = res.data.difficulty_level_list;
            this.Level_listAll = res.data.difficulty_level_list_All;
          }
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    console.log("sel_crs", this.sel_crs);
    this.call();
    this.getdifficultylevel();
    this.radios = 'qb'
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>